module.exports = __webpack_public_path__ + "img/d20061016-2.bfa96974.jpg";